(function() {
    /* ======================================================================
       Multicolumn Video — Swiper mobile + Play/Pause
       Based on multicolumn.js
       ====================================================================== */

    let swiperInstances = [];

    // ---- Swiper helpers ----

    const addClasses = () => {
        document.querySelectorAll('.mcv-list__item').forEach((slide) => {
            slide.classList.add('swiper-slide');
        });
    };

    const initSlider = () => {
        const sliders = document.querySelectorAll('.swiper--mcv');

        if (sliders && sliders.length > 0) {
            sliders.forEach((slider) => {
                const btnPrev = slider.querySelector('.mcv__button-prev');
                const btnNext = slider.querySelector('.mcv__button-next');

                const instance = new Swiper(slider, {
                    loop: false,
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            spaceBetween: 0,
                        },
                        640: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                            spaceBetween: 24,
                        },
                    },
                    navigation: {
                        nextEl: btnNext,
                        prevEl: btnPrev,
                    },
                });

                swiperInstances.push(instance);
            });
        }
    };

    const destroySlider = () => {
        const slides = document.querySelectorAll('.mcv-list__item');

        swiperInstances.forEach((swiper) => {
            if (swiper && swiper.destroy) {
                swiper.destroy(true, true);
            }
        });
        swiperInstances = [];

        slides.forEach((slide) => {
            slide.removeAttribute('style');
            slide.classList.remove('swiper-slide');
        });
    };

    const initSwiper = () => {
        const section = document.querySelector('.multicolumn-video-section');
        if (!section) return;

        const hasSwiper = section.querySelector('.swiper--mcv');

        const observer = new ResizeObserver((entries) => {
            const [entry] = entries;

            if (entry.contentRect.width < 991 && hasSwiper) {
                addClasses();
                initSlider();
            } else if (swiperInstances.length > 0) {
                destroySlider();
            }
        });

        observer.observe(section);
    };

    // ---- Video Play / Pause ----

    const initVideoControls = () => {
        document.querySelectorAll('.mcv-card__play-btn').forEach((btn) => {
            btn.addEventListener('click', function() {
                const wrapper = this.closest('.mcv-card__video-wrapper');
                const video = wrapper ? wrapper.querySelector('video') : null;
                if (!video) return;

                if (video.paused) {
                    video.play();
                    this.classList.add('is-playing');
                    this.setAttribute('aria-label', 'Mettre en pause');
                } else {
                    video.pause();
                    this.classList.remove('is-playing');
                    this.setAttribute('aria-label', 'Lire la vidéo');
                }
            });
        });

        // Sync button state when video ends (if not looping)
        document.querySelectorAll('.mcv-card__video').forEach((video) => {
            video.addEventListener('ended', function() {
                const wrapper = this.closest('.mcv-card__video-wrapper');
                const btn = wrapper ? wrapper.querySelector('.mcv-card__play-btn') : null;
                if (btn) {
                    btn.classList.remove('is-playing');
                    btn.setAttribute('aria-label', 'Lire la vidéo');
                }
            });
        });
    };

    // ---- Init ----

    const init = () => {
        if (swiperInstances.length > 0) {
            destroySlider();
        }
        addClasses();
        initSwiper();
        initSlider();
        initVideoControls();
    };

    init();

    document.addEventListener('shopify:section:load', function() {
        init();
    });
})();